/**
 * Générateur — Automatisme : dans un repère orthogonal, placer un point de
 * coordonnées données.
 * Attendu ID : 1237 | Niveau : 3ème | Domaine : Espace et géométrie, Repérage
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 l. 1064-1066).
 *
 * Les clés placer_* et croix_* de gen_1236 (un fichier « repère », deux jeux
 * de clés, modèle 1213/1246, base du prof du 13/09) : figure, tirages et
 * sacrifié (2 ; −3) sont ceux de gen_1236 ; les payloads portent déjà
 * l'attendu 1237.
 */
import { genererParmi, CATEGORIES_PLACER } from './gen_1236';

export const CATEGORIES = CATEGORIES_PLACER;
const CLES = CATEGORIES_PLACER.flatMap((c) => c.formatsList.map(({ key }) => key));
export const generate = (typeExercice) => genererParmi(CLES, typeExercice);
